// import { a } from "node_modules/framer-motion/dist/types.d-DagZKalS";
const localeMap: Record<string, string> = {
  'en-IN': 'INR',
  'en-US': 'USD',
  'en-GB': 'GBP',
  // Add others as needed
};
   const regionMapping: Record<string, string> = {
      'IN': 'INR',
      'US': 'USD',
      'GB': 'GBP',
      'ZA': 'ZAR',
      // Add major regions you expect
    };
      const tzMapping: Record<string, string> = {
    "Asia/Calcutta": "INR",
    "Asia/Kolkata": "INR",

    "America/New_York": "USD",
    "America/Chicago": "USD",
    "America/Denver": "USD",
    "America/Los_Angeles": "USD",
    "Europe/London": "GBP",
    "Europe/Paris": "EUR",
    "Europe/Berlin": "EUR",
    "Australia/Sydney": "AUD",
    "Asia/Dubai": "AED",
    "Africa/Johannesburg": "ZAR"
  };

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getCurrencyFromTimeZone = (): string => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; 

  console.log("timezone", timeZone)
  return tzMapping[timeZone] || "USD"; // Default to USD if unknown
};

export const getAutoCurrency = (): string => {
  try {
    // Attempt to get region from locale (e.g., 'en-IN' -> 'IN')
    const region = new Intl.Locale(window.navigator.language).region;
    
 

    return regionMapping[region || ''] || 'USD'; // Default to USD
  } catch (e) {
    return 'USD'; // Fallback
  }
};


export const userLocale=()=>{
    const userLocale=navigator.languages && navigator.languages.length? navigator.languages[0]: navigator.language;
    return userLocale
}

const getSymbol = (locale:string, currencyCode:string) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
  })
    .formatToParts(0)
    .find(part => part.type === 'currency').value;
};



export const getUserCurrencySymbol=()=> {
//     const locale= userLocale()
//     const currency=localeMap[locale]
    
//    return getSymbol(locale, currency)
    // const locale= userLocale()
    // console.log("user locale", locale)

  const code = getCurrencyFromTimeZone();
      console.log("user currency", code)

  return new Intl.NumberFormat("en-IN", {
    style: 'currency',
    currency: code,
  }).formatToParts(0).find(p => p.type === 'currency')?.value || '$';
}


export const formatCurrency = (amount: number) => {
     const currencyCode = getCurrencyFromTimeZone();

  const cu= new Intl.NumberFormat(window.navigator.language, {
    style: 'currency',
    currency: currencyCode,
    // Optional: simplifies "100.00" to "100" if there are no cents
    minimumFractionDigits: 0, 
    maximumFractionDigits: 2,
  }).format(amount);
  return cu.substring(1, cu.length)
};